import React from "react";

import { Link } from "react-router-dom";

import { useUser } from "@components/user-context";
import { IconButton } from "@shared/buttons";

interface PrintPageButtonProps {
  className?: string;
  search: string;
}

export function PrintPageButton({ className, search }: PrintPageButtonProps) {
  const { user } = useUser();

  return (
    <Link
      to={`${user.pathFromRoot("/overview-print")}${search}`}
      className="no-underline"
    >
      <IconButton
        className={className}
        size="md"
        variant="secondary"
        leftIcon={<i className="fa-regular fa-sharp fa-print" />}
      >
        PRINT PAGE
      </IconButton>
    </Link>
  );
}
